import { combineReducers } from 'redux';

// reducers
import { agendaReducer }   from '../modules/agenda/store/reducer';
import { checkoutReducer } from '../modules/checkout/store/reducer';


const rootReducer = combineReducers({
  agenda:   agendaReducer,
  checkout: checkoutReducer,
});



export default rootReducer;